import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';

import type { TAutocompleteBaseValue } from '../../autocompleteBase.type';
import type { IGetValue, ISetInitialValue } from './localValue.util.type';

export const getValue = ({
  availableValues,
  value,
  multiple,
  defaultLocalValue,
  // Its ok in this place
  // eslint-disable-next-line sonarjs/function-return-type
}: IGetValue): TAutocompleteBaseValue => {
  if (multiple) {
    return availableValues.filter(({ value: optionValue }) => includes(value, optionValue));
  }

  return (
    availableValues.find(({ value: optionValue }) => includes(value, optionValue)) ||
    defaultLocalValue
  );
};

export const setInitialValue = ({
  handleChange,
  value,
  localValue,
  multiple,
  availableValues,
  defaultLocalValue,
}: ISetInitialValue): void => {
  // clear localValue after clear outside
  if (!isEmpty(localValue) && isEmpty(value)) {
    handleChange(defaultLocalValue, availableValues, 'localChange');

    return;
  }

  // set localValue or clear outside if no found value in availableValues
  if (!!availableValues.length && !isEmpty(value)) {
    const newValue = getValue({ availableValues, value, multiple, defaultLocalValue });
    const needClearFieldOutside = isEmpty(localValue) && isEmpty(newValue);

    handleChange(newValue, availableValues, needClearFieldOutside ? 'clear' : 'localChange');
  }
};
